import { Reducer } from 'redux';
import { IEndpointAction } from '../action';

/**
 * The factory method to create the current endpoint reducer
 *
 * @export
 * @returns {Reducer<string, IEndpointAction>}
 */
export function createEndpointReducer(
): Reducer<string, IEndpointAction> {
  const reducer: Reducer<string> = (state = '', action) => {

    switch (action.type) {

      case 'ENDPOINT': {
        return action?.payload?.endpoint ?? '';
      }

      default: {
        return state;
      }
    }
  };

  return reducer;
}

// Create and combine all the reducers involved with the endpoint functionality
//
export const endpointReducers = {
  endpointUrl: createEndpointReducer(),
};
